<template>
  <div>
    <div class="d-flex justify-center pt-4">
      <period-picker :periods="predictionPeriodList" :selected-period="selectedPeriod"
                     @period-selected="onSelectPeriod" v-if="predictionPeriodListLoaded"/>
    </div>

    <group-forecaster v-if="selectedPeriodLoaded" :originRouteProp="originRoute"/>
  </div>
</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';
import { Components, MapGetters } from '@core/helpers/decorators';
import GroupForecaster from '@groupForecaster/GroupForecaster';
import PeriodPicker from '@optimizer/components/PeriodPicker';

@Component
@Components({ GroupForecaster, PeriodPicker })
@MapGetters(['predictionPeriodList', 'nextPeriod'])
export default class GroupForecasterManager extends Vue {
  get selectedPeriod() {
    if (this.$route.params.periodGuid) {
      return this.predictionPeriodList.find((period) => period.guid === this.$route.params.periodGuid);
    }
    return this.nextPeriod || this.predictionPeriodList[0];
  }

  get originRoute() {
    return { name: 'optimizer-pro' };
  }

  get selectedPeriodLoaded() {
    return this.$route.params.periodGuid;
  }

  get predictionPeriodListLoaded() {
    return this.predictionPeriodList && this.predictionPeriodList.length > 0;
  }

  async created() {
    this.setPeriodRoute();
  }

  setPeriodRoute() {
    const periodGuid = (this.nextPeriod && this.nextPeriod.guid) || this.predictionPeriodList[0].guid;
    if (!this.$route.params.periodGuid && periodGuid) {
      this.$router.replace({ name: this.$route.name, params: { ...this.$route.params, periodGuid } });
    }
  }

  onSelectPeriod(newSelectedPeriod) {
    if (this.selectedPeriod && this.selectedPeriod.guid !== newSelectedPeriod.guid) {
      this.$router.replace({
        name: this.$route.name,
        params: { ...this.$route.params, periodGuid: newSelectedPeriod.guid }
      });
    }
  }
}

</script>

<style scoped></style>
